import React, { useState, useEffect } from "react";
import Fetch from "../common/Fetch";
import Select from "react-select";
import { withContext } from "../context/AppContext";

const countryList = [
  {
    name: "India",
    code: "IN",
    flag: "https://restcountries.eu/data/ind.svg",
    dial_code: "+91",
  },
  {
    name: "Afghanistan",
    code: "AF",
    flag: "https://restcountries.eu/data/afg.svg",
    dial_code: "+93",
  },
  {
    name: "Åland Islands",
    code: "AX",
    flag: "https://restcountries.eu/data/ala.svg",
    dial_code: "+358",
  },
  {
    name: "Albania",
    code: "AL",
    flag: "https://restcountries.eu/data/alb.svg",
    dial_code: "+355",
  },
  {
    name: "Algeria",
    code: "DZ",
    flag: "https://restcountries.eu/data/dza.svg",
    dial_code: "+213",
  },
  {
    name: "American Samoa",
    code: "AS",
    flag: "https://restcountries.eu/data/asm.svg",
    dial_code: "+1684",
  },
  {
    name: "Andorra",
    code: "AD",
    flag: "https://restcountries.eu/data/and.svg",
    dial_code: "+376",
  },
  {
    name: "Angola",
    code: "AO",
    flag: "https://restcountries.eu/data/ago.svg",
    dial_code: "+244",
  },
  {
    name: "Anguilla",
    code: "AI",
    flag: "https://restcountries.eu/data/aia.svg",
    dial_code: "+1264",
  },
  {
    name: "Antarctica",
    code: "AQ",
    flag: "https://restcountries.eu/data/ata.svg",
    dial_code: "+672",
  },
  {
    name: "Antigua and Barbuda",
    code: "AG",
    flag: "https://restcountries.eu/data/atg.svg",
    dial_code: "+1268",
  },
  {
    name: "Argentina",
    code: "AR",
    flag: "https://restcountries.eu/data/arg.svg",
    dial_code: "+54",
  },
  {
    name: "Armenia",
    code: "AM",
    flag: "https://restcountries.eu/data/arm.svg",
    dial_code: "+374",
  },
  {
    name: "Aruba",
    code: "AW",
    flag: "https://restcountries.eu/data/abw.svg",
    dial_code: "+297",
  },
  {
    name: "Australia",
    code: "AU",
    flag: "https://restcountries.eu/data/aus.svg",
    dial_code: "+61",
  },
  {
    name: "Austria",
    code: "AT",
    flag: "https://restcountries.eu/data/aut.svg",
    dial_code: "+43",
  },
  {
    name: "Azerbaijan",
    code: "AZ",
    flag: "https://restcountries.eu/data/aze.svg",
    dial_code: "+994",
  },
  {
    name: "Bahamas",
    code: "BS",
    flag: "https://restcountries.eu/data/bhs.svg",
    dial_code: "+1242",
  },
  {
    name: "Bahrain",
    code: "BH",
    flag: "https://restcountries.eu/data/bhr.svg",
    dial_code: "+973",
  },
  {
    name: "Bangladesh",
    code: "BD",
    flag: "https://restcountries.eu/data/bgd.svg",
    dial_code: "+880",
  },
  {
    name: "Barbados",
    code: "BB",
    flag: "https://restcountries.eu/data/brb.svg",
    dial_code: "+1246",
  },
  {
    name: "Belarus",
    code: "BY",
    flag: "https://restcountries.eu/data/blr.svg",
    dial_code: "+375",
  },
  {
    name: "Belgium",
    code: "BE",
    flag: "https://restcountries.eu/data/bel.svg",
    dial_code: "+32",
  },
  {
    name: "Belize",
    code: "BZ",
    flag: "https://restcountries.eu/data/blz.svg",
    dial_code: "+501",
  },
  {
    name: "Benin",
    code: "BJ",
    flag: "https://restcountries.eu/data/ben.svg",
    dial_code: "+229",
  },
  {
    name: "Bermuda",
    code: "BM",
    flag: "https://restcountries.eu/data/bmu.svg",
    dial_code: "+1441",
  },
  {
    name: "Bhutan",
    code: "BT",
    flag: "https://restcountries.eu/data/btn.svg",
    dial_code: "+975",
  },
  {
    name: "Bolivia (Plurinational State of)",
    code: "BO",
    flag: "https://restcountries.eu/data/bol.svg",
    dial_code: "+591",
  },
  {
    name: "Bonaire, Sint Eustatius and Saba",
    code: "BQ",
    flag: "https://restcountries.eu/data/bes.svg",
    dial_code: "+5997",
  },
  {
    name: "Bosnia and Herzegovina",
    code: "BA",
    flag: "https://restcountries.eu/data/bih.svg",
    dial_code: "+387",
  },
  {
    name: "Botswana",
    code: "BW",
    flag: "https://restcountries.eu/data/bwa.svg",
    dial_code: "+267",
  },
  // {name: "Bouvet Island", code: "BV", flag: "https://restcountries.eu/data/bvt.svg", dial_code: "+"},
  {
    name: "Brazil",
    code: "BR",
    flag: "https://restcountries.eu/data/bra.svg",
    dial_code: "+55",
  },
  {
    name: "British Indian Ocean Territory",
    code: "IO",
    flag: "https://restcountries.eu/data/iot.svg",
    dial_code: "+246",
  },
  // {name: "United States Minor Outlying Islands", code: "UM", flag: "https://restcountries.eu/data/umi.svg", dial_code: "+"},
  {
    name: "Virgin Islands (British)",
    code: "VG",
    flag: "https://restcountries.eu/data/vgb.svg",
    dial_code: "+1284",
  },
  {
    name: "Virgin Islands (U.S.)",
    code: "VI",
    flag: "https://restcountries.eu/data/vir.svg",
    dial_code: "+1",
  },
  {
    name: "Brunei Darussalam",
    code: "BN",
    flag: "https://restcountries.eu/data/brn.svg",
    dial_code: "+673",
  },
  {
    name: "Bulgaria",
    code: "BG",
    flag: "https://restcountries.eu/data/bgr.svg",
    dial_code: "+359",
  },
  {
    name: "Burkina Faso",
    code: "BF",
    flag: "https://restcountries.eu/data/bfa.svg",
    dial_code: "+226",
  },
  {
    name: "Burundi",
    code: "BI",
    flag: "https://restcountries.eu/data/bdi.svg",
    dial_code: "+257",
  },
  {
    name: "Cambodia",
    code: "KH",
    flag: "https://restcountries.eu/data/khm.svg",
    dial_code: "+855",
  },
  {
    name: "Cameroon",
    code: "CM",
    flag: "https://restcountries.eu/data/cmr.svg",
    dial_code: "+237",
  },
  {
    name: "Canada",
    code: "CA",
    flag: "https://restcountries.eu/data/can.svg",
    dial_code: "+1",
  },
  {
    name: "Cabo Verde",
    code: "CV",
    flag: "https://restcountries.eu/data/cpv.svg",
    dial_code: "+238",
  },
  {
    name: "Cayman Islands",
    code: "KY",
    flag: "https://restcountries.eu/data/cym.svg",
    dial_code: "+1345",
  },
  {
    name: "Central African Republic",
    code: "CF",
    flag: "https://restcountries.eu/data/caf.svg",
    dial_code: "+236",
  },
  {
    name: "Chad",
    code: "TD",
    flag: "https://restcountries.eu/data/tcd.svg",
    dial_code: "+235",
  },
  {
    name: "Chile",
    code: "CL",
    flag: "https://restcountries.eu/data/chl.svg",
    dial_code: "+56",
  },
  {
    name: "China",
    code: "CN",
    flag: "https://restcountries.eu/data/chn.svg",
    dial_code: "+86",
  },
  // {name: "Christmas Island", code: "CX", flag: "https://restcountries.eu/data/cxr.svg", dial_code: "+61"},
  // {name: "Cocos (Keeling) Islands", code: "CC", flag: "https://restcountries.eu/data/cck.svg", dial_code: "+61"},
  {
    name: "Colombia",
    code: "CO",
    flag: "https://restcountries.eu/data/col.svg",
    dial_code: "+57",
  },
  {
    name: "Comoros",
    code: "KM",
    flag: "https://restcountries.eu/data/com.svg",
    dial_code: "+269",
  },
  {
    name: "Congo",
    code: "CG",
    flag: "https://restcountries.eu/data/cog.svg",
    dial_code: "+242",
  },
  {
    name: "Congo (Democratic Republic of the)",
    code: "CD",
    flag: "https://restcountries.eu/data/cod.svg",
    dial_code: "+243",
  },
  {
    name: "Cook Islands",
    code: "CK",
    flag: "https://restcountries.eu/data/cok.svg",
    dial_code: "+682",
  },
  {
    name: "Costa Rica",
    code: "CR",
    flag: "https://restcountries.eu/data/cri.svg",
    dial_code: "+506",
  },
  {
    name: "Croatia",
    code: "HR",
    flag: "https://restcountries.eu/data/hrv.svg",
    dial_code: "+385",
  },
  {
    name: "Cuba",
    code: "CU",
    flag: "https://restcountries.eu/data/cub.svg",
    dial_code: "+53",
  },
  {
    name: "Curaçao",
    code: "CW",
    flag: "https://restcountries.eu/data/cuw.svg",
    dial_code: "+599",
  },
  {
    name: "Cyprus",
    code: "CY",
    flag: "https://restcountries.eu/data/cyp.svg",
    dial_code: "+357",
  },
  {
    name: "Czech Republic",
    code: "CZ",
    flag: "https://restcountries.eu/data/cze.svg",
    dial_code: "+420",
  },
  {
    name: "Denmark",
    code: "DK",
    flag: "https://restcountries.eu/data/dnk.svg",
    dial_code: "+45",
  },
  {
    name: "Djibouti",
    code: "DJ",
    flag: "https://restcountries.eu/data/dji.svg",
    dial_code: "+253",
  },
  {
    name: "Dominica",
    code: "DM",
    flag: "https://restcountries.eu/data/dma.svg",
    dial_code: "+1767",
  },
  {
    name: "Dominican Republic",
    code: "DO",
    flag: "https://restcountries.eu/data/dom.svg",
    dial_code: "+1849",
  },
  {
    name: "Ecuador",
    code: "EC",
    flag: "https://restcountries.eu/data/ecu.svg",
    dial_code: "+593",
  },
  {
    name: "Egypt",
    code: "EG",
    flag: "https://restcountries.eu/data/egy.svg",
    dial_code: "+20",
  },
  {
    name: "El Salvador",
    code: "SV",
    flag: "https://restcountries.eu/data/slv.svg",
    dial_code: "+503",
  },
  {
    name: "Equatorial Guinea",
    code: "GQ",
    flag: "https://restcountries.eu/data/gnq.svg",
    dial_code: "+240",
  },
  {
    name: "Eritrea",
    code: "ER",
    flag: "https://restcountries.eu/data/eri.svg",
    dial_code: "+291",
  },
  {
    name: "Estonia",
    code: "EE",
    flag: "https://restcountries.eu/data/est.svg",
    dial_code: "+372",
  },
  {
    name: "Ethiopia",
    code: "ET",
    flag: "https://restcountries.eu/data/eth.svg",
    dial_code: "+251",
  },
  {
    name: "Falkland Islands (Malvinas)",
    code: "FK",
    flag: "https://restcountries.eu/data/flk.svg",
    dial_code: "+500",
  },
  {
    name: "Faroe Islands",
    code: "FO",
    flag: "https://restcountries.eu/data/fro.svg",
    dial_code: "+298",
  },
  {
    name: "Fiji",
    code: "FJ",
    flag: "https://restcountries.eu/data/fji.svg",
    dial_code: "+679",
  },
  {
    name: "Finland",
    code: "FI",
    flag: "https://restcountries.eu/data/fin.svg",
    dial_code: "+358",
  },
  {
    name: "France",
    code: "FR",
    flag: "https://restcountries.eu/data/fra.svg",
    dial_code: "+33",
  },
  {
    name: "French Guiana",
    code: "GF",
    flag: "https://restcountries.eu/data/guf.svg",
    dial_code: "+594",
  },
  {
    name: "French Polynesia",
    code: "PF",
    flag: "https://restcountries.eu/data/pyf.svg",
    dial_code: "+689",
  },
  // {name: "French Southern Territories", code: "TF", flag: "https://restcountries.eu/data/atf.svg", dial_code: "+"},
  {
    name: "Gabon",
    code: "GA",
    flag: "https://restcountries.eu/data/gab.svg",
    dial_code: "+241",
  },
  {
    name: "Gambia",
    code: "GM",
    flag: "https://restcountries.eu/data/gmb.svg",
    dial_code: "+220",
  },
  {
    name: "Georgia",
    code: "GE",
    flag: "https://restcountries.eu/data/geo.svg",
    dial_code: "+995",
  },
  {
    name: "Germany",
    code: "DE",
    flag: "https://restcountries.eu/data/deu.svg",
    dial_code: "+49",
  },
  {
    name: "Ghana",
    code: "GH",
    flag: "https://restcountries.eu/data/gha.svg",
    dial_code: "+233",
  },
  {
    name: "Gibraltar",
    code: "GI",
    flag: "https://restcountries.eu/data/gib.svg",
    dial_code: "+350",
  },
  {
    name: "Greece",
    code: "GR",
    flag: "https://restcountries.eu/data/grc.svg",
    dial_code: "+30",
  },
  {
    name: "Greenland",
    code: "GL",
    flag: "https://restcountries.eu/data/grl.svg",
    dial_code: "+299",
  },
  {
    name: "Grenada",
    code: "GD",
    flag: "https://restcountries.eu/data/grd.svg",
    dial_code: "+1473",
  },
  {
    name: "Guadeloupe",
    code: "GP",
    flag: "https://restcountries.eu/data/glp.svg",
    dial_code: "+590",
  },
  {
    name: "Guam",
    code: "GU",
    flag: "https://restcountries.eu/data/gum.svg",
    dial_code: "+1671",
  },
  {
    name: "Guatemala",
    code: "GT",
    flag: "https://restcountries.eu/data/gtm.svg",
    dial_code: "+502",
  },
  {
    name: "Guernsey",
    code: "GG",
    flag: "https://restcountries.eu/data/ggy.svg",
    dial_code: "+44",
  },
  {
    name: "Guinea",
    code: "GN",
    flag: "https://restcountries.eu/data/gin.svg",
    dial_code: "+224",
  },
  {
    name: "Guinea-Bissau",
    code: "GW",
    flag: "https://restcountries.eu/data/gnb.svg",
    dial_code: "+245",
  },
  {
    name: "Guyana",
    code: "GY",
    flag: "https://restcountries.eu/data/guy.svg",
    dial_code: "+592",
  },
  {
    name: "Haiti",
    code: "HT",
    flag: "https://restcountries.eu/data/hti.svg",
    dial_code: "+509",
  },
  {
    name: "Holy See",
    code: "VA",
    flag: "https://restcountries.eu/data/vat.svg",
    dial_code: "+379",
  },
  {
    name: "Honduras",
    code: "HN",
    flag: "https://restcountries.eu/data/hnd.svg",
    dial_code: "+504",
  },
  {
    name: "Hong Kong",
    code: "HK",
    flag: "https://restcountries.eu/data/hkg.svg",
    dial_code: "+852",
  },
  {
    name: "Hungary",
    code: "HU",
    flag: "https://restcountries.eu/data/hun.svg",
    dial_code: "+36",
  },
  {
    name: "Iceland",
    code: "IS",
    flag: "https://restcountries.eu/data/isl.svg",
    dial_code: "+354",
  },
  {
    name: "Indonesia",
    code: "ID",
    flag: "https://restcountries.eu/data/idn.svg",
    dial_code: "+62",
  },
  {
    name: "Côte d'Ivoire",
    code: "CI",
    flag: "https://restcountries.eu/data/civ.svg",
    dial_code: "+225",
  },
  {
    name: "Iran (Islamic Republic of)",
    code: "IR",
    flag: "https://restcountries.eu/data/irn.svg",
    dial_code: "+98",
  },
  {
    name: "Iraq",
    code: "IQ",
    flag: "https://restcountries.eu/data/irq.svg",
    dial_code: "+964",
  },
  {
    name: "Ireland",
    code: "IE",
    flag: "https://restcountries.eu/data/irl.svg",
    dial_code: "+353",
  },
  {
    name: "Isle of Man",
    code: "IM",
    flag: "https://restcountries.eu/data/imn.svg",
    dial_code: "+44",
  },
  {
    name: "Israel",
    code: "IL",
    flag: "https://restcountries.eu/data/isr.svg",
    dial_code: "+972",
  },
  {
    name: "Italy",
    code: "IT",
    flag: "https://restcountries.eu/data/ita.svg",
    dial_code: "+39",
  },
  {
    name: "Jamaica",
    code: "JM",
    flag: "https://restcountries.eu/data/jam.svg",
    dial_code: "+1876",
  },
  {
    name: "Japan",
    code: "JP",
    flag: "https://restcountries.eu/data/jpn.svg",
    dial_code: "+81",
  },
  {
    name: "Jersey",
    code: "JE",
    flag: "https://restcountries.eu/data/jey.svg",
    dial_code: "+44",
  },
  {
    name: "Jordan",
    code: "JO",
    flag: "https://restcountries.eu/data/jor.svg",
    dial_code: "+962",
  },
  {
    name: "Kazakhstan",
    code: "KZ",
    flag: "https://restcountries.eu/data/kaz.svg",
    dial_code: "+77",
  },
  {
    name: "Kenya",
    code: "KE",
    flag: "https://restcountries.eu/data/ken.svg",
    dial_code: "+254",
  },
  {
    name: "Kiribati",
    code: "KI",
    flag: "https://restcountries.eu/data/kir.svg",
    dial_code: "+686",
  },
  {
    name: "Kuwait",
    code: "KW",
    flag: "https://restcountries.eu/data/kwt.svg",
    dial_code: "+965",
  },
  {
    name: "Kyrgyzstan",
    code: "KG",
    flag: "https://restcountries.eu/data/kgz.svg",
    dial_code: "+996",
  },
  {
    name: "Lao People's Democratic Republic",
    code: "LA",
    flag: "https://restcountries.eu/data/lao.svg",
    dial_code: "+856",
  },
  {
    name: "Latvia",
    code: "LV",
    flag: "https://restcountries.eu/data/lva.svg",
    dial_code: "+371",
  },
  {
    name: "Lebanon",
    code: "LB",
    flag: "https://restcountries.eu/data/lbn.svg",
    dial_code: "+961",
  },
  {
    name: "Lesotho",
    code: "LS",
    flag: "https://restcountries.eu/data/lso.svg",
    dial_code: "+266",
  },
  {
    name: "Liberia",
    code: "LR",
    flag: "https://restcountries.eu/data/lbr.svg",
    dial_code: "+231",
  },
  {
    name: "Libya",
    code: "LY",
    flag: "https://restcountries.eu/data/lby.svg",
    dial_code: "+218",
  },
  {
    name: "Liechtenstein",
    code: "LI",
    flag: "https://restcountries.eu/data/lie.svg",
    dial_code: "+423",
  },
  {
    name: "Lithuania",
    code: "LT",
    flag: "https://restcountries.eu/data/ltu.svg",
    dial_code: "+370",
  },
  {
    name: "Luxembourg",
    code: "LU",
    flag: "https://restcountries.eu/data/lux.svg",
    dial_code: "+352",
  },
  {
    name: "Macao",
    code: "MO",
    flag: "https://restcountries.eu/data/mac.svg",
    dial_code: "+853",
  },
  {
    name: "Macedonia (the former Yugoslav Republic of)",
    code: "MK",
    flag: "https://restcountries.eu/data/mkd.svg",
    dial_code: "+389",
  },
  {
    name: "Madagascar",
    code: "MG",
    flag: "https://restcountries.eu/data/mdg.svg",
    dial_code: "+261",
  },
  {
    name: "Malawi",
    code: "MW",
    flag: "https://restcountries.eu/data/mwi.svg",
    dial_code: "+265",
  },
  {
    name: "Malaysia",
    code: "MY",
    flag: "https://restcountries.eu/data/mys.svg",
    dial_code: "+60",
  },
  {
    name: "Maldives",
    code: "MV",
    flag: "https://restcountries.eu/data/mdv.svg",
    dial_code: "+960",
  },
  {
    name: "Mali",
    code: "ML",
    flag: "https://restcountries.eu/data/mli.svg",
    dial_code: "+223",
  },
  {
    name: "Malta",
    code: "MT",
    flag: "https://restcountries.eu/data/mlt.svg",
    dial_code: "+356",
  },
  {
    name: "Marshall Islands",
    code: "MH",
    flag: "https://restcountries.eu/data/mhl.svg",
    dial_code: "+692",
  },
  {
    name: "Martinique",
    code: "MQ",
    flag: "https://restcountries.eu/data/mtq.svg",
    dial_code: "+596",
  },
  {
    name: "Mauritania",
    code: "MR",
    flag: "https://restcountries.eu/data/mrt.svg",
    dial_code: "+222",
  },
  {
    name: "Mauritius",
    code: "MU",
    flag: "https://restcountries.eu/data/mus.svg",
    dial_code: "+230",
  },
  {
    name: "Mayotte",
    code: "YT",
    flag: "https://restcountries.eu/data/myt.svg",
    dial_code: "+262",
  },
  {
    name: "Mexico",
    code: "MX",
    flag: "https://restcountries.eu/data/mex.svg",
    dial_code: "+52",
  },
  {
    name: "Micronesia (Federated States of)",
    code: "FM",
    flag: "https://restcountries.eu/data/fsm.svg",
    dial_code: "+691",
  },
  {
    name: "Moldova (Republic of)",
    code: "MD",
    flag: "https://restcountries.eu/data/mda.svg",
    dial_code: "+373",
  },
  {
    name: "Monaco",
    code: "MC",
    flag: "https://restcountries.eu/data/mco.svg",
    dial_code: "+377",
  },
  {
    name: "Mongolia",
    code: "MN",
    flag: "https://restcountries.eu/data/mng.svg",
    dial_code: "+976",
  },
  {
    name: "Montenegro",
    code: "ME",
    flag: "https://restcountries.eu/data/mne.svg",
    dial_code: "+382",
  },
  {
    name: "Montserrat",
    code: "MS",
    flag: "https://restcountries.eu/data/msr.svg",
    dial_code: "+1664",
  },
  {
    name: "Morocco",
    code: "MA",
    flag: "https://restcountries.eu/data/mar.svg",
    dial_code: "+212",
  },
  {
    name: "Mozambique",
    code: "MZ",
    flag: "https://restcountries.eu/data/moz.svg",
    dial_code: "+258",
  },
  {
    name: "Myanmar",
    code: "MM",
    flag: "https://restcountries.eu/data/mmr.svg",
    dial_code: "+95",
  },
  {
    name: "Namibia",
    code: "NA",
    flag: "https://restcountries.eu/data/nam.svg",
    dial_code: "+264",
  },
  {
    name: "Nauru",
    code: "NR",
    flag: "https://restcountries.eu/data/nru.svg",
    dial_code: "+674",
  },
  {
    name: "Nepal",
    code: "NP",
    flag: "https://restcountries.eu/data/npl.svg",
    dial_code: "+977",
  },
  {
    name: "Netherlands",
    code: "NL",
    flag: "https://restcountries.eu/data/nld.svg",
    dial_code: "+31",
  },
  {
    name: "New Caledonia",
    code: "NC",
    flag: "https://restcountries.eu/data/ncl.svg",
    dial_code: "+687",
  },
  {
    name: "New Zealand",
    code: "NZ",
    flag: "https://restcountries.eu/data/nzl.svg",
    dial_code: "+64",
  },
  {
    name: "Nicaragua",
    code: "NI",
    flag: "https://restcountries.eu/data/nic.svg",
    dial_code: "+505",
  },
  {
    name: "Niger",
    code: "NE",
    flag: "https://restcountries.eu/data/ner.svg",
    dial_code: "+227",
  },
  {
    name: "Nigeria",
    code: "NG",
    flag: "https://restcountries.eu/data/nga.svg",
    dial_code: "+234",
  },
  {
    name: "Niue",
    code: "NU",
    flag: "https://restcountries.eu/data/niu.svg",
    dial_code: "+683",
  },
  {
    name: "Norfolk Island",
    code: "NF",
    flag: "https://restcountries.eu/data/nfk.svg",
    dial_code: "+672",
  },
  {
    name: "Korea (Democratic People's Republic of)",
    code: "KP",
    flag: "https://restcountries.eu/data/prk.svg",
    dial_code: "+850",
  },
  {
    name: "Northern Mariana Islands",
    code: "MP",
    flag: "https://restcountries.eu/data/mnp.svg",
    dial_code: "+1670",
  },
  {
    name: "Norway",
    code: "NO",
    flag: "https://restcountries.eu/data/nor.svg",
    dial_code: "+47",
  },
  {
    name: "Oman",
    code: "OM",
    flag: "https://restcountries.eu/data/omn.svg",
    dial_code: "+968",
  },
  {
    name: "Pakistan",
    code: "PK",
    flag: "https://restcountries.eu/data/pak.svg",
    dial_code: "+92",
  },
  {
    name: "Palau",
    code: "PW",
    flag: "https://restcountries.eu/data/plw.svg",
    dial_code: "+680",
  },
  {
    name: "Palestine, State of",
    code: "PS",
    flag: "https://restcountries.eu/data/pse.svg",
    dial_code: "+970",
  },
  {
    name: "Panama",
    code: "PA",
    flag: "https://restcountries.eu/data/pan.svg",
    dial_code: "+507",
  },
  {
    name: "Papua New Guinea",
    code: "PG",
    flag: "https://restcountries.eu/data/png.svg",
    dial_code: "+675",
  },
  {
    name: "Paraguay",
    code: "PY",
    flag: "https://restcountries.eu/data/pry.svg",
    dial_code: "+595",
  },
  {
    name: "Peru",
    code: "PE",
    flag: "https://restcountries.eu/data/per.svg",
    dial_code: "+51",
  },
  {
    name: "Philippines",
    code: "PH",
    flag: "https://restcountries.eu/data/phl.svg",
    dial_code: "+63",
  },
  {
    name: "Pitcairn",
    code: "PN",
    flag: "https://restcountries.eu/data/pcn.svg",
    dial_code: "+64",
  },
  {
    name: "Poland",
    code: "PL",
    flag: "https://restcountries.eu/data/pol.svg",
    dial_code: "+48",
  },
  {
    name: "Portugal",
    code: "PT",
    flag: "https://restcountries.eu/data/prt.svg",
    dial_code: "+351",
  },
  {
    name: "Puerto Rico",
    code: "PR",
    flag: "https://restcountries.eu/data/pri.svg",
    dial_code: "+1939",
  },
  {
    name: "Qatar",
    code: "QA",
    flag: "https://restcountries.eu/data/qat.svg",
    dial_code: "+974",
  },
  {
    name: "Republic of Kosovo",
    code: "XK",
    flag: "https://restcountries.eu/data/kos.svg",
    dial_code: "+383",
  },
  {
    name: "Réunion",
    code: "RE",
    flag: "https://restcountries.eu/data/reu.svg",
    dial_code: "+262",
  },
  {
    name: "Romania",
    code: "RO",
    flag: "https://restcountries.eu/data/rou.svg",
    dial_code: "+40",
  },
  {
    name: "Russian Federation",
    code: "RU",
    flag: "https://restcountries.eu/data/rus.svg",
    dial_code: "+7",
  },
  {
    name: "Rwanda",
    code: "RW",
    flag: "https://restcountries.eu/data/rwa.svg",
    dial_code: "+250",
  },
  {
    name: "Saint Barthélemy",
    code: "BL",
    flag: "https://restcountries.eu/data/blm.svg",
    dial_code: "+590",
  },
  {
    name: "Saint Helena, Ascension and Tristan da Cunha",
    code: "SH",
    flag: "https://restcountries.eu/data/shn.svg",
    dial_code: "+290",
  },
  {
    name: "Saint Kitts and Nevis",
    code: "KN",
    flag: "https://restcountries.eu/data/kna.svg",
    dial_code: "+1869",
  },
  {
    name: "Saint Lucia",
    code: "LC",
    flag: "https://restcountries.eu/data/lca.svg",
    dial_code: "+1758",
  },
  {
    name: "Saint Martin (French part)",
    code: "MF",
    flag: "https://restcountries.eu/data/maf.svg",
    dial_code: "+590",
  },
  {
    name: "Saint Pierre and Miquelon",
    code: "PM",
    flag: "https://restcountries.eu/data/spm.svg",
    dial_code: "+508",
  },
  {
    name: "Saint Vincent and the Grenadines",
    code: "VC",
    flag: "https://restcountries.eu/data/vct.svg",
    dial_code: "+1784",
  },
  {
    name: "Samoa",
    code: "WS",
    flag: "https://restcountries.eu/data/wsm.svg",
    dial_code: "+685",
  },
  {
    name: "San Marino",
    code: "SM",
    flag: "https://restcountries.eu/data/smr.svg",
    dial_code: "+378",
  },
  {
    name: "Sao Tome and Principe",
    code: "ST",
    flag: "https://restcountries.eu/data/stp.svg",
    dial_code: "+239",
  },
  {
    name: "Saudi Arabia",
    code: "SA",
    flag: "https://restcountries.eu/data/sau.svg",
    dial_code: "+966",
  },
  {
    name: "Senegal",
    code: "SN",
    flag: "https://restcountries.eu/data/sen.svg",
    dial_code: "+221",
  },
  {
    name: "Serbia",
    code: "RS",
    flag: "https://restcountries.eu/data/srb.svg",
    dial_code: "+381",
  },
  {
    name: "Seychelles",
    code: "SC",
    flag: "https://restcountries.eu/data/syc.svg",
    dial_code: "+248",
  },
  {
    name: "Sierra Leone",
    code: "SL",
    flag: "https://restcountries.eu/data/sle.svg",
    dial_code: "+232",
  },
  ,
  {
    name: "Singapore",
    code: "SG",
    flag: "https://restcountries.eu/data/sgp.svg",
    dial_code: "+65",
  },
  {
    name: "Sint Maarten (Dutch part)",
    code: "SX",
    flag: "https://restcountries.eu/data/sxm.svg",
    dial_code: "+1721",
  },
  {
    name: "Slovakia",
    code: "SK",
    flag: "https://restcountries.eu/data/svk.svg",
    dial_code: "+421",
  },
  {
    name: "Slovenia",
    code: "SI",
    flag: "https://restcountries.eu/data/svn.svg",
    dial_code: "+386",
  },
  {
    name: "Solomon Islands",
    code: "SB",
    flag: "https://restcountries.eu/data/slb.svg",
    dial_code: "+677",
  },
  {
    name: "Somalia",
    code: "SO",
    flag: "https://restcountries.eu/data/som.svg",
    dial_code: "+252",
  },
  {
    name: "South Africa",
    code: "ZA",
    flag: "https://restcountries.eu/data/zaf.svg",
    dial_code: "+27",
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    code: "GS",
    flag: "https://restcountries.eu/data/sgs.svg",
    dial_code: "+500",
  },
  {
    name: "Korea (Republic of)",
    code: "KR",
    flag: "https://restcountries.eu/data/kor.svg",
    dial_code: "+82",
  },
  {
    name: "South Sudan",
    code: "SS",
    flag: "https://restcountries.eu/data/ssd.svg",
    dial_code: "+211",
  },
  {
    name: "Spain",
    code: "ES",
    flag: "https://restcountries.eu/data/esp.svg",
    dial_code: "+34",
  },
  {
    name: "Sri Lanka",
    code: "LK",
    flag: "https://restcountries.eu/data/lka.svg",
    dial_code: "+94",
  },
  {
    name: "Sudan",
    code: "SD",
    flag: "https://restcountries.eu/data/sdn.svg",
    dial_code: "+249",
  },
  {
    name: "Suriname",
    code: "SR",
    flag: "https://restcountries.eu/data/sur.svg",
    dial_code: "+597",
  },
  {
    name: "Svalbard and Jan Mayen",
    code: "SJ",
    flag: "https://restcountries.eu/data/sjm.svg",
    dial_code: "+4779",
  },
  {
    name: "Swaziland",
    code: "SZ",
    flag: "https://restcountries.eu/data/swz.svg",
    dial_code: "+268",
  },
  {
    name: "Sweden",
    code: "SE",
    flag: "https://restcountries.eu/data/swe.svg",
    dial_code: "+46",
  },
  {
    name: "Switzerland",
    code: "CH",
    flag: "https://restcountries.eu/data/che.svg",
    dial_code: "+41",
  },
  {
    name: "Syrian Arab Republic",
    code: "SY",
    flag: "https://restcountries.eu/data/syr.svg",
    dial_code: "+963",
  },
  {
    name: "Taiwan",
    code: "TW",
    flag: "https://restcountries.eu/data/twn.svg",
    dial_code: "+886",
  },
  {
    name: "Tajikistan",
    code: "TJ",
    flag: "https://restcountries.eu/data/tjk.svg",
    dial_code: "+992",
  },
  {
    name: "Tanzania, United Republic of",
    code: "TZ",
    flag: "https://restcountries.eu/data/tza.svg",
    dial_code: "+255",
  },
  {
    name: "Thailand",
    code: "TH",
    flag: "https://restcountries.eu/data/tha.svg",
    dial_code: "+66",
  },
  {
    name: "Timor-Leste",
    code: "TL",
    flag: "https://restcountries.eu/data/tls.svg",
    dial_code: "+670",
  },
  {
    name: "Togo",
    code: "TG",
    flag: "https://restcountries.eu/data/tgo.svg",
    dial_code: "+228",
  },
  {
    name: "Tokelau",
    code: "TK",
    flag: "https://restcountries.eu/data/tkl.svg",
    dial_code: "+690",
  },
  {
    name: "Tonga",
    code: "TO",
    flag: "https://restcountries.eu/data/ton.svg",
    dial_code: "+676",
  },
  {
    name: "Trinidad and Tobago",
    code: "TT",
    flag: "https://restcountries.eu/data/tto.svg",
    dial_code: "+1868",
  },
  {
    name: "Tunisia",
    code: "TN",
    flag: "https://restcountries.eu/data/tun.svg",
    dial_code: "+216",
  },
  {
    name: "Turkey",
    code: "TR",
    flag: "https://restcountries.eu/data/tur.svg",
    dial_code: "+90",
  },
  {
    name: "Turkmenistan",
    code: "TM",
    flag: "https://restcountries.eu/data/tkm.svg",
    dial_code: "+993",
  },
  {
    name: "Turks and Caicos Islands",
    code: "TC",
    flag: "https://restcountries.eu/data/tca.svg",
    dial_code: "+1649",
  },
  {
    name: "Tuvalu",
    code: "TV",
    flag: "https://restcountries.eu/data/tuv.svg",
    dial_code: "+688",
  },
  {
    name: "Uganda",
    code: "UG",
    flag: "https://restcountries.eu/data/uga.svg",
    dial_code: "+256",
  },
  {
    name: "Ukraine",
    code: "UA",
    flag: "https://restcountries.eu/data/ukr.svg",
    dial_code: "+380",
  },
  {
    name: "United Arab Emirates",
    code: "AE",
    flag: "https://restcountries.eu/data/are.svg",
    dial_code: "+971",
  },
  {
    name: "United Kingdom of Great Britain and Northern Ireland",
    code: "GB",
    flag: "https://restcountries.eu/data/gbr.svg",
    dial_code: "+44",
  },
  {
    name: "United States of America",
    code: "US",
    flag: "https://restcountries.eu/data/usa.svg",
    dial_code: "+1",
  },
  {
    name: "Uruguay",
    code: "UY",
    flag: "https://restcountries.eu/data/ury.svg",
    dial_code: "+598",
  },
  {
    name: "Uzbekistan",
    code: "UZ",
    flag: "https://restcountries.eu/data/uzb.svg",
    dial_code: "+998",
  },
  {
    name: "Vanuatu",
    code: "VU",
    flag: "https://restcountries.eu/data/vut.svg",
    dial_code: "+678",
  },
  {
    name: "Venezuela (Bolivarian Republic of)",
    code: "VE",
    flag: "https://restcountries.eu/data/ven.svg",
    dial_code: "+58",
  },
  {
    name: "Viet Nam",
    code: "VN",
    flag: "https://restcountries.eu/data/vnm.svg",
    dial_code: "+84",
  },
  {
    name: "Wallis and Futuna",
    code: "WF",
    flag: "https://restcountries.eu/data/wlf.svg",
    dial_code: "+681",
  },
  {
    name: "Western Sahara",
    code: "EH",
    flag: "https://restcountries.eu/data/esh.svg",
    dial_code: "+212",
  },
  {
    name: "Yemen",
    code: "YE",
    flag: "https://restcountries.eu/data/yem.svg",
    dial_code: "+967",
  },
  {
    name: "Zambia",
    code: "ZM",
    flag: "https://restcountries.eu/data/zmb.svg",
    dial_code: "+260",
  },
  {
    name: "Zimbabwe",
    code: "ZW",
    flag: "https://restcountries.eu/data/zwe.svg",
    dial_code: "+263",
  },
];

const CountryCodePicker = ({ className, getCountryCode, classNamePrefix }) => {
  const [countryCode, setCountryCode] = useState({
    value: String(countryList[0].dial_code),
    label: (
      <div>
        {/* <img height="20px" width="20px" src={countryList[0].flag} alt="flag"></img> */}
        {countryList[0].dial_code}
      </div>
    ),
  });

  const handleChange = (selectedOption) => {
    // console.log("selectedOption", selectedOption);
    setCountryCode(selectedOption);
    getCountryCode(selectedOption.value);
  };

  // useEffect(() => {
  const el =
    document.getElementById("react-select-5-input") &&
    document.getElementById("react-select-5-input");
  if (el) {
    el.setAttribute("maxLength", "7");
  }
  // }, [])

  return (
    <React.Fragment>
      <Select
        classNamePrefix={classNamePrefix}
        value={countryCode}
        className={className}
        onChange={handleChange}
        options={countryList.map((d, i) => {
          return {
            key: i,
            value: d.dial_code,
            label: (
              <div>
                {/* <img height="20px" width="20px" src={d.flag} alt="flag"></img> */}
                {d.dial_code}
              </div>
            ),
          };
        })}
      />
    </React.Fragment>
  );
};

export default CountryCodePicker;
